// extracted by mini-css-extract-plugin
var _1 = "ra-profile-info-body";
var _2 = "ra-profile-info";
var _3 = "ra-profile-info-framed";
var _4 = "ra-profile-info-header";
var _5 = "ra-profile-info-heading";
var _6 = "ra-profile-info-heading-label";
export { _1 as "profileInfoBodyCls", _2 as "profileInfoCls", _3 as "profileInfoFramedCls", _4 as "profileInfoHeaderCls", _5 as "profileInfoHeadingCls", _6 as "profileInfoHeadingLabelCls" }
